var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8193 5.35125C13.3047 4.02022 12.4114 2.86914 11.2497 2.04029C10.0881 1.21143 8.70904 0.741126 7.28302 0.6875C5.85699 0.741126 4.47794 1.21143 3.31629 2.04029C2.15465 2.86914 1.26134 4.02022 0.746767 5.35125C0.712015 5.44737 0.712015 5.55263 0.746767 5.64875C1.26134 6.97978 2.15465 8.13086 3.31629 8.95971C4.47794 9.78857 5.85699 10.2589 7.28302 10.3125C8.70904 10.2589 10.0881 9.78857 11.2497 8.95971C12.4114 8.13086 13.3047 6.97978 13.8193 5.64875C13.854 5.55263 13.854 5.44737 13.8193 5.35125ZM7.28302 8.34375C6.72058 8.34375 6.17077 8.17697 5.70311 7.86449C5.23546 7.55202 4.87097 7.10788 4.65574 6.58826C4.4405 6.06863 4.38418 5.49685 4.49391 4.94521C4.60364 4.39358 4.87448 3.88687 5.27218 3.48917C5.66989 3.09146 6.1766 2.82062 6.72823 2.71089C7.27986 2.60117 7.85165 2.65748 8.37127 2.87272C8.8909 3.08795 9.33503 3.45245 9.64751 3.9201C9.95998 4.38775 10.1268 4.93756 10.1268 5.5C10.1256 6.25385 9.82563 6.9765 9.29257 7.50956C8.75952 8.04261 8.03687 8.34259 7.28302 8.34375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/ic_view.245ed8d706d5e01fc08634f5c851aebd.svg";
export { ForwardRef as ReactComponent };